// @ts-nocheck
/* eslint-disable */
export const appSend24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 11.5H22M17 16.5L22 11.5L17 6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'send-24' as const
};